import * as React from 'react';
import { SVGProps } from 'react';

const IconLithologyStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 7h2v2H4V7ZM12 7h-2v2h2V7ZM7 10h2v2H7v-2ZM9 4H7v2h2V4Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2Zm2 1v10h10V3H3Z"
    />
  </svg>
);
export default IconLithologyStrokedSizeS;
